<template>
  <b-row>
    <b-col xl='12' lg='12'>
      <Widget title="
            <div>
              <h4>
                Detail Perizinan
              </h4>
            </div>" customHeader>
        <form-wizard shape="tab" color="#3498db" title="" subtitle="" @on-change="updateProgress"
          @on-loading="updateProgress(1, 1)">
          <b-progress class="progress-xs" variant="info" :value="progress" :max="4" />
          <b-button slot="prev" variant="primary" id="back" hidden class="text-white">
            <i class="fa fa-caret-left" /> Previous
          </b-button>
          <b-button slot="next" variant="primary" id="next" hidden class="text-white">
            Next <i class="fa fa-caret-right" />
          </b-button>
          <b-button @click="$router.push('/app/perizinan')" slot="finish" variant="success" id="finish" hidden
            class="text-white">
            Finish <i class="fa fa-check" />
          </b-button>
          <tab-content title="1. Profil">
            <TabProfil @nextDokumen="nextDokumen" :dataPermohonan="dataPermohonan" :dataKBLI="dataKBLI" :dataKlasifikasi="dataKlasifikasi"/>
          </tab-content>
          <tab-content title="2. Dokumen">
            <TabDokumen @nextDokumen="nextDokumen" :dataUser="dataUser" @previousDokumen="previousDokumen" :dataPermohonan="dataPermohonan" />
          </tab-content>
          <tab-content title="3. Teknis">
            <TabTeknis @nextDokumen="nextDokumen" :dataProvinsi="dataProvinsi" :dataKabupaten="dataKabupaten" :dataKecamatan="dataKecamatan" 
              :dataKlasifikasi="dataKlasifikasi" :dataJenisPermohonan="dataJenisPermohonan" @getKecamatan="getKecamatan" @getKabupaten="getKabupaten" @previousDokumen="previousDokumen" :wygEditor="wygEditor"
              :dataPermohonan="dataPermohonan" />
          </tab-content>
          <tab-content title="4. BA">
            <TabBA @finishDokumen="finishDokumen" :dataProvinsi="dataProvinsi" :dataKabupaten="dataKabupaten" :dataKecamatan="dataKecamatan" 
              :dataKlasifikasi="dataKlasifikasi" :dataJenisPermohonan="dataJenisPermohonan" @getKecamatan="getKecamatan" @getKabupaten="getKabupaten" @previousDokumen="previousDokumen" :wygEditor="wygEditor"
              :dataPermohonan="dataPermohonan" :dataTtd="dataTtd" :dataKordinat="dataKordinat" />
          </tab-content>
        </form-wizard>
      </Widget>
    </b-col>
  </b-row>
</template>
  
<script>
import Vue from 'vue';
import vSelect from 'vue-select';
import Widget from '@/components/Widget/Widget';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import axios from 'axios';
import DatePicker from 'vue2-datepicker';
import TabProfil from './Profil/Profil';
import TabDokumen from './Dokumen/Dokumen';
import TabTeknis from './Teknis/Teknis';
import TabBA from './BA/BA';

//   import { select2CountriesData, select2ShipmentData, cardTypesData } from './data';

export default {
  name: 'FormWizardPage',
  components: { Widget, vSelect, ClassicEditor, DatePicker, TabProfil, TabDokumen, TabTeknis, TabBA },
  data() {
    return {
      baseapi: localStorage.getItem("baseapi"),
      user: JSON.parse(localStorage.getItem('user')),
      progress: 1,
      dataJenisProyek: [],
      dataRisiko: [],
      dataSkalaUsaha: [],
      dataStatusVerdok: [],
      dataPerDokumen: [],
      dataPermohonan: [],
      radioOne: 0,
      wygEditor: ClassicEditor,
      dataJenisPermohonan: [],
      dataKlasifikasi: [],
      dataStatusPentek: [],
      dataHasilPentek: [],
      dataProvinsi: [],
      dataKecamatan: [],
      dataKabupaten: [],
      dataTtd: [],
      dataKordinat: [],
      dataUser: [],
      dataKBLI: []

    };
  },
  mounted() {
    this.getRisiko()
    this.getJenisProyek()
    this.getJenisPermohonan()
    this.getSkalaUsaha()
    this.getStatusVerdok()
    this.getKlasifikasi()
    this.getProvinsi()
    this.getHasilPentek()
    this.getStatusPentek()
    this.getProvinsi()
    this.getTtd()
    this.getKordinat()
    this.getUser()
    this.getKBLI()
    this.loaddata()
  },
  methods: {
    updateProgress(prevIndex, nextIndex) {
      if (nextIndex >= 0) {
        Vue.set(this, 'progress', nextIndex + 1);
      }
    },

    changeRadio(field, index) {
      Vue.set(this, field, index);
    },

    //   get jenis proyek
    getJenisProyek() {
      axios.get(this.baseapi + "api/jenis_proyek", {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataJenisProyek = response.data.data;
      }).catch(error => {
        console.log(error)
        return error
      });
    },

    getKBLI() {
      axios.get(this.baseapi + "api/kbli", {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataKBLI = response.data.data;
      }).catch(error => {
        console.log(error)
        return error
      });
    },

    getUser(){
        axios.get(this.baseapi + "api/user", {
            headers: {
            Authorization: `Bearer ` + this.user.accessToken
            }
        }).then(response => {
            let data = []
            data = response.data.data;

            for (let index = 0; index < data.length; index++) {
                if (data[index].role === 'admin_kkp') {
                    this.dataUser.push({nama: data[index].nama +'-'+ data[index].nama_provinsi, id: data[index].id})
                } else if (data[index].role === 'admin_upt') {
                    this.dataUser.push({nama: data[index].nama +'-'+ data[index].nama_provinsi, id: data[index].id})
                } else {
                    continue
                }
            }
            console.log(this.dataUser)
        }).catch(error => {
            console.log(error)
            return error
        });
    },


    getKordinat() {
        axios.get(this.baseapi + "api/kordinat?filter=id_permohonan,=,"+this.$route.params.id, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken
          }
        }).then(response => {
          this.dataKordinat = response.data.data;
        }).catch(error => {
          console.log(error)
          return error
        });
      },

    // ttd
    getTtd(){
        axios.get(this.baseapi + "api/tandatangan", {
            headers: {
                Authorization: `Bearer ` + this.user.accessToken
            }
        }).then(response => {
            this.dataTtd = response.data.data;
        }).catch(error => {
            return error
        });
    },

    // get status verdok
    getStatusPentek() {
      axios.get(this.baseapi + "api/status_vertek", {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataStatusPentek = response.data.data;
      }).catch(error => {
        console.log(error)
        return error
      });
    },

    // get hasil vertek
    getHasilPentek() {
      axios.get(this.baseapi + "api/hasil_vertek", {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataHasilPentek = response.data.data;
      }).catch(error => {
        console.log(error)
        return error
      });
    },

    // get provinsi
    getProvinsi() {
      axios.get(this.baseapi + "api/provinsi", {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataProvinsi = response.data.data;
      }).catch(error => {
        console.log(error)
        return error
      });
    },

    // get kabupaten
    getKabupaten(nama){
        axios.get(this.baseapi + "api/kabupaten?filter=nama_provinsi,=,"+nama, {
            headers: {
                Authorization: `Bearer ` + this.user.accessToken
            }
        }).then(response => {
            this.dataKabupaten = response.data.data;
        }).catch(error => {
            return error
        });
    },

    getKecamatan(nama){
        axios.get(this.baseapi + "api/kecamatan?filter=nama_kabupaten,=,"+nama, {
            headers: {
                Authorization: `Bearer ` + this.user.accessToken
            }
        }).then(response => {
            this.dataKecamatan = response.data.data;
        }).catch(error => {
            return error
        });
    },

    // get jenis Permohonan
    getJenisPermohonan() {
      axios.get(this.baseapi + "api/jenis_permohonan", {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataJenisPermohonan = response.data.data;
      }).catch(error => {
        console.log(error)
        return error
      });
    },

    // get klasifikasi
    getKlasifikasi() {
      axios.get(this.baseapi + "api/klasifikasi_pemohon", {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataKlasifikasi = response.data.data;
      }).catch(error => {
        console.log(error)
        return error
      });
    },

    simpanProfil() {
      document.getElementById("next").click();
    },

    nextDokumen() {
      document.getElementById("next").click();
    },

    previousDokumen() {
      document.getElementById("back").click();
    },

    // simpan hasil
    finishDokumen() {
      document.getElementById("finish").click();
    },

    // get rsiiko
    getRisiko() {
      axios.get(this.baseapi + "api/risiko", {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataRisiko = response.data.data;
      }).catch(error => {
        console.log(error)
        return error
      });
    },

    // get prvonsin
    getProvinsi() {
      axios.get(this.baseapi + "api/provinsi", {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataProvinsi = response.data.data;
      }).catch(error => {
        return error
      });
    },

    // get skala usaha
    getSkalaUsaha() {
      axios.get(this.baseapi + "api/skala_usaha", {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataSkalaUsaha = response.data.data;
      }).catch(error => {
        console.log(error)
        return error
      });
    },


    // load data
    loaddata() {
      axios.get(this.baseapi + "api/notifikasi_izin_lokasi/" + this.$route.params.id, {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataPermohonan = response.data.data;
        this.dataPermohonan['file_1'] = null
        this.dataPermohonan['file_2'] = null
        this.dataPermohonan['file_3'] = null
        this.dataPermohonan['file_4'] = null
        this.dataPermohonan['file_5'] = null
        this.dataPermohonan['file_6'] = null
        if (this.dataPermohonan.hasil_tambahan === null) {
          this.dataPermohonan.hasil_tambahan = []
        } else {
          let array = []
          array = this.dataPermohonan.hasil_tambahan.split("||")
          console.log(array)

          let array2 = []

          for (let index = 0; index < array.length; index++) {
            array2.push({ data: array[index] })

          }
          array = this.dataPermohonan.hasil_tambahan = array2
        }
        console.log(this.dataPermohonan)
      }).catch(error => {
        console.log(error)
        return error
      });
    },

    // tambah hasil lain
    addHasil() {
      this.dataPermohonan.hasil_tambahan.push({ data: null })
    },

    // delete hasil lain
    deleteHasil(index) {
      this.dataPermohonan.hasil_tambahan.splice(index, 1);
    },

    // get status verdok
    getStatusVerdok() {
      axios.get(this.baseapi + "api/status_verdok", {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then(response => {
        this.dataStatusVerdok = response.data.data;
      }).catch(error => {
        console.log(error)
        return error
      });
    },
  },
};
</script>
  
  <style src="../Wizard.scss" lang="scss" />
  